import { gql } from '@apollo/client'

const SET_IS_CURATION_ENABLED_DIET_MUTATION = gql`
  mutation setIsCurationEnabledDiet(
    $id: ID!
    $isCurationEnabled: Boolean!
    $type: String!
  ) {
    setIsCurationEnabledDiet(
      id: $id
      isCurationEnabled: $isCurationEnabled
      type: $type
    ) {
      id
      name
      isCurationEnabled
      level
      idPath
      namePath
      type
      parentId
    }
  }
`

export default SET_IS_CURATION_ENABLED_DIET_MUTATION
